@if (state$ | async; as state) {
  <div class="automation-warning" role="presentation">
    <button
      type="button"
      class="automation-warning__scrim"
      aria-label="Cancel automation drift warning"
      (click)="warningService.cancel()"
    ></button>
    <section
      class="automation-warning__dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="automation-warning-title"
    >
      <header class="automation-warning__header">
        <span class="automation-warning__icon" sch-icon="warning-fill"></span>
        <div>
          <p class="ops-eyebrow">Automation drift risk</p>
          <h2 id="automation-warning-title">
            This resource may be managed outside Operations
          </h2>
        </div>
      </header>

      <div class="automation-warning__body">
        <p>
          You are about to {{ state.operation }}
          {{ state.itemName || state.resource }}. This area can also be managed
          by SSDT, CI/CD, seed scripts, or deployment automation.
        </p>
        <p>
          Continuing can create drift, overwrite production-only values, or be
          overwritten by the next automated deployment. The action will be
          specially tagged in audit for reconciliation and rollback review.
        </p>
      </div>

      <div class="automation-warning__acknowledgement">
        <seech-checkbox
          id="automation-drift-confirmation"
          label="I understand the automation drift risk and want to continue."
          [selected]="state.confirmed"
          (selectedChange)="warningService.setConfirmed($event)"
        />
      </div>

      <footer class="automation-warning__actions">
        <button
          sch-button
          variant="outline"
          color="primary"
          size="sm"
          type="button"
          (click)="warningService.cancel()"
        >
          Cancel
        </button>
        <button
          sch-button
          variant="solid"
          color="danger"
          size="sm"
          type="button"
          [disabled]="!state.confirmed"
          (click)="warningService.proceed()"
        >
          <span sch-icon="warning-fill"></span>
          Continue
        </button>
      </footer>
    </section>
  </div>
}
